import PrivateLayoutTopBar from 'layout/PrivateLayout/PrivateLayoutTopBar'
import privateLayoutStyle from 'layout/PrivateLayout/privateLayoutStyle'
import PropTypes from 'prop-types'
import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import {getCurrentUser} from 'redux/action/authAction'
import withStyles from '@material-ui/core/styles/withStyles'

const PrivateLayout = (props) => {
  const {classes, children, getCurrentUser, currentUser, currentUserLoading} = props

  useEffect(() => {
    getCurrentUser()
  }, [])

  return (
    <div className={classes.root}>
      <PrivateLayoutTopBar loading={currentUserLoading} currentUser={currentUser} />

      <main className={classes.content}>{children}</main>
    </div>
  )
}

PrivateLayout.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  getCurrentUser: PropTypes.func,
  currentUser: PropTypes.object,
  currentUserLoading: PropTypes.bool,
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCurrentUser,
    },
    dispatch
  )
}

export default compose(
  withStyles(privateLayoutStyle),
  connect((store) => {
    return {
      currentUser: store.auth.currentUser,
      currentUserLoading: store.auth.currentUserLoading,
    }
  }, mapDispatchToProps)
)(PrivateLayout)
